<template>
  <div>
    <b-form-group
      class="input-group-var-sector-sanitari"
      label="Sector sanitari:"
      label-size="sm"
      label-for="input-var-sector-sanitari"
      label-cols="4"
    >
      <b-form-select
        required
        size="sm"
        id="input-var-sector-sanitari"
        class="var-sector-sanitari"
        v-model="sectorSanitari"
        :options="opcionsSectorSanitari"
        @input="onUpdateSectorSanitari"
      >
        <template v-slot:first>
          <b-form-select-option :value="null">Totes</b-form-select-option>
        </template>
      </b-form-select>
    </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableSectorSanitari",
  props: {
    initialValue: {
      required: true,
    },
  },
  data() {
    return {
      codiVariable: "sector-sanitari",
      sectorSanitari: null,
      opcionsSectorSanitari: [
        { value: "1", text: "Aran" },
        { value: "2", text: "Alt Pirineu" },
        { value: "3", text: "Lleida" },
        { value: "4", text: "Tarragonès - Baix Penedès" },
        { value: "5", text: "Baix Camp - Priorat" },
        { value: "6", text: "Alt Camp - Conca de Barberà" },
        { value: "7", text: "Terres de l'Ebre" },
        { value: "8", text: "Girona Sud" },
        { value: "9", text: "Girona Nord" },
        { value: "10", text: "Solsonès - Bages - Berguedà" },
        { value: "11", text: "Anoia" },
        { value: "12", text: "Osona" },
        { value: "13", text: "Barcelona Ciutat Vella" },
        { value: "14", text: "Barcelona Eixample" },
        { value: "15", text: "Barcelona Sants-Montjuïc" },
        { value: "16", text: "Barcelona Les Corts" },
        { value: "17", text: "Barcelona Sarrià-Sant Gervasi" },
        { value: "18", text: "Barcelona Gràcia" },
        { value: "19", text: "Barcelona Horta-Guinardó" },
        { value: "20", text: "Barcelona Nou Barris" },
        { value: "21", text: "Barcelona Sant Andreu" },
        { value: "22", text: "Barcelona Sant Martí" },
        { value: "23", text: "Barcelonès Nord i Maresme" },
        { value: "24", text: "Vallès Oriental" },
        { value: "25", text: "Vallès Occidental Est" },
        { value: "26", text: "Vallès Occidental Oest" },
        {
          value: "27",
          text: "Baix Llobregat Centre-Litoral i l'Hospitalet de Llobregat",
        },
        { value: "28", text: "Baix Llobregat Nord" },
        { value: "29", text: "Alt Penedès - Garraf" },
      ],
    };
  },
  computed: {
    returnValue() {
      let r = { codi: this.codiVariable };
      if (this.sectorSanitari != null) {
        r.valor = this.sectorSanitari;
      }

      return r;
    },
  },
  methods: {
    onUpdateSectorSanitari(newValue) {
      console.log(newValue);
      if (this.returnValue.valor) {
        this.$emit("variable-editada", this.returnValue);
      } else {
        this.$emit("variable-eliminada", this.codiVariable);
      }
    },
  },
  mounted() {
    if (this.initialValue != null) {
      this.sectorSanitari = this.initialValue.valor;
    }
  },
};
</script>

<style scoped>
.var-sector-sanitari {
  width: 180px;
}
.input-group-var-sector-sanitari .col {
  text-align: left;
}
</style>
